module.exports = __webpack_public_path__ + "img/about-1-lg.eed69810.png";